import { GridRow, GridRowProps } from "@mui/x-data-grid-pro";
import { useSortable } from "@dnd-kit/sortable";
import { Property } from "csstype";
import React from "react";
import clsx from "clsx";
import styles from './Explorer.module.scss';

export function ExplorerItemRowPlaylist(props: GridRowProps) {
  const {
    isDragging,
  } = useSortable({ id: props.row.id });
  const style = {
    position: 'relative' as Property.Position,
    ...(isDragging && {
      opacity: 0,
    }),
  };

  return (
    <div
      style={style}
      className={
        clsx({
          [styles.Folder]: true,
        })
      }
    >
      <GridRow
        data-type={props.row.type}
        {...props}
      />
    </div>
  );
}
